export const FETCH_APPLICATION_LOADING = "FETCH_APPLICATION_LOADING";
export const FETCH_APPLICATION = "FETCH_APPLICATION";
export const FETCH_HEADER_LOADING = "FETCH_HEADER_LOADING";
export const FETCH_HEADER = "FETCH_HEADER";
export const FETCH_TOOL_LOADING = "FETCH_TOOL_LOADING";
export const FETCH_TOOL = "FETCH_TOOL";
